import { render, staticRenderFns } from "./division-selection.vue?vue&type=template&id=b1f6fc7e&scoped=true"
import script from "./division-selection.vue?vue&type=script&lang=js"
export * from "./division-selection.vue?vue&type=script&lang=js"
import style0 from "./division-selection.vue?vue&type=style&index=0&id=b1f6fc7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f6fc7e",
  null
  
)

export default component.exports